export default __webpack_public_path__ + "static/img4_question_groups-0e2c14e49a9d1087f09fc012685dcc66.png";